<template>
  <div class="p-8">
    <slot />
  </div>
</template>